<template>
  <div class="page-error">
    <img :src="require('./404.png')" style="height: 200px;" />
    <p class="error">网络不稳定或其它原因, 资源文件加载失败, 请重试</p>
    <p class="error" style="font-size: 12px;">{{entry}}</p>
    <el-button style="margin-top: 28px;" type="primary" @click="reload">重新加载</el-button>
  </div>
</template>
<script>
export default {
    name: 'remote-error',
    data: function() {
      return {
        entry: this.$route.query.entry
      }
    },
    methods: {
      reload () {
        this.$router.replace(this.$route.query.reload)
      },
    },
  }
</script>
<style lang='scss'>
  @import "index.scss";
</style>



// WEBPACK FOOTER //
// src/layout/layout/error-page/remote-404.vue